import React from "react";
import { useLocation } from "react-router-dom";
import QPhototModuleSubtopic from "../../QPhotoModuleSubtopic";

const ALL_CN_SUBTOPICS = [
    { name: 'Data Communications and Networking: A Communications Model – Data Communications Evolution of network, Requirements, Applications', path: '/cn-m1-s1' },
    { name: 'Network Topology', path: '/cn-m1-s2' },
    { name: 'Protocols and Standards', path: '/cn-m1-s3' },
    { name: 'Network Models (OSI, TCP/IP)', path: '/cn-m1-s4' },
    { name: 'Circuit and Packet Switching', path: '/cn-m2-s1' },
    { name: 'Networking Parameters (Transmission Impairment, Data Rate and Performance)', path: '/cn-m2-s2' },
    { name: 'Error Detection and Correction – Hamming Code, CRC, Checksum', path: '/cn-m3-s1' },
    { name: 'Flow control mechanism – Sliding Window Protocol - GoBack - N - Selective Repeat', path: '/cn-m3-s2' },
    { name: 'Multiple access Aloha - Slotted Aloha', path: '/cn-m3-s3' },
    { name: 'CSMA, CSMA/CD', path: '/cn-m3-s4' },
    { name: 'IEEE Standards(IEEE802.3 (Ethernet), IEEE802.11(WLAN))- RFID- Bluetooth Standards', path: '/cn-m3-s5' },
    { name: 'IPv4 Address Space – Notations – Classful Addressing – Classless Addressing', path: '/cn-m4-s1' },
    { name: 'Network Address Translation', path: '/cn-m4-s2' },
    { name: 'IPv6 Address Structure – IPv4 and IPv6 header format', path: '/cn-m4-s3' },
    { name: 'Routing - Link State and Distance Vector Routing Protocols - Implementation - Performance Analysis - Packet Tracer', path: '/cn-m5-s1' },
    { name: 'TCP and UDP', path: '/cn-m6-s1' },
    { name: 'Congestion Control, Traffic Management, QoS', path: '/cn-m6-s2' },
    { name: 'Application Layer, DNS, FTP, HTTP, SMTP, SNMP', path: '/cn-m7-s1' }
];

const CNModuleSubtopic = ({ title, videos, pdfLink, takeaways, questions, exampleVideos }) => {
    const location = useLocation();
    const { subtopics = ALL_CN_SUBTOPICS, subjectPath = '/subject-CNModules' } = location.state || {};

    return (
        <QPhototModuleSubtopic
            title={title}
            videos={videos}
            pdfLink={pdfLink}
            takeaways={takeaways}
            questions={questions}
            exampleVideos={exampleVideos}
            subtopics={subtopics || ALL_CN_SUBTOPICS}
            subjectPath={subjectPath}
        />
    );
};

export default CNModuleSubtopic;
